import { Box, Divider, List, Paper } from '@mui/material';
import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { LuFileClock, LuLoader, LuMail, LuPhone, LuPlane } from 'react-icons/lu';
import { IJobCandidateInteraction } from 'wisestep-api';
import { WsColors } from 'wisestep-base';

import { setDefaultCandidateAdvanceFilters } from '../../../features/candidates/utils/CandidateHelper';
import AdvancedFiltersHeader from '../../../utils/AdvancedFiltersHeader';
import {
  CreatedBwDatesFilter,
  CurrentEmployersFilter,
  JobTitleFilter,
  JobTypeFilter,
  LanguagesFilter,
  NoticePeriod,
  PreviousEmployersFilter,
  SalaryRangeFilter,
  SourceFilter,
  TagsFilter,
  TotalExperienceFilter,
} from '../components';
import {
  contactPreferences,
  jobPreferences,
  workAuthorization,
} from '../components/AdvanceFilterHelper';
import CheckboxListFilter from '../components/CheckboxListFilter';
import TalentPoolAdvanceFilterFormProps from '../models/TalentPoolAdvanceFiltersFormProps';

const TalentPoolAdvancesFiltersNew = ({ onApplyFilters, defaultValues }) => {
  const methods = useForm<TalentPoolAdvanceFilterFormProps>({
    defaultValues: defaultValues,
  });
  const { handleSubmit, reset } = methods;

  const onFormSubmit = (data: TalentPoolAdvanceFilterFormProps) => {
    onApplyFilters(data);
  };
  const candidateStatus = {
    submitted: 'submitted',
    uploaded: 'uploaded',
    applied: 'applied',
  };
  useEffect(() => {
    reset(defaultValues);
  }, [defaultValues, reset]);
  return (
    <FormProvider {...methods}>
      <Paper sx={{ mt: 2 }}>
        <Box
          component="form"
          role="presentation"
          onSubmit={handleSubmit(onFormSubmit)}
          onReset={() => {
            reset(setDefaultCandidateAdvanceFilters({} as IJobCandidateInteraction));
            onFormSubmit({});
          }}
        >
          <AdvancedFiltersHeader />
          <Divider />
          <List>
            <JobTitleFilter name="jobTitles" title="Job Title(s)" showAccordionIcon={true} />
            <CreatedBwDatesFilter
              name="createBWDates.fromDateName"
              name1="createBWDates.toDateName"
              showAccordionIcon={true}
            />
            <CheckboxListFilter
              name="workAuthorization"
              options={workAuthorization}
              title="Work Authorization"
              startIcon={<LuPlane color={WsColors.TertiaryShades800} />}
            />
            <SourceFilter
              name="source"
              defaultValue={defaultValues.source}
              showAccordionIcon={true}
            />
            <CheckboxListFilter
              name="commPreference"
              options={contactPreferences}
              title="Communication Preference"
              startIcon={<LuMail color={WsColors.TertiaryShades800} />}
            />
            <CurrentEmployersFilter
              name="currentEmployers"
              defaultValue={defaultValues.currentEmployers}
              showAccordionIcon={true}
            />
            <PreviousEmployersFilter
              name="previousEmployers"
              defaultValue={defaultValues.previousEmployers}
              showAccordionIcon={true}
            />
            <CheckboxListFilter
              name="contactAvailability"
              options={contactPreferences}
              title="Contact Availability"
              startIcon={<LuPhone color={WsColors.TertiaryShades800} />}
            />
            <SalaryRangeFilter showAccordionIcon={true} />
            <NoticePeriod name="noticePeriod" showAccordionIcon={true} />
            <LanguagesFilter name="languages" showAccordionIcon={true} />
            <JobTypeFilter name="jobType" showAccordionIcon={true} />
            <CheckboxListFilter
              name="jobPreference"
              options={jobPreferences}
              title="Job Preference"
              startIcon={<LuFileClock color={WsColors.TertiaryShades800} />}
            />
            <TotalExperienceFilter />
            <CheckboxListFilter
              name="candidateStatus"
              options={candidateStatus}
              title="Status"
              startIcon={<LuLoader color={WsColors.TertiaryShades800} />}
            />
            <TagsFilter name="tags" defaultValue={defaultValues.tags} showAccordionIcon={true} />
          </List>
        </Box>
      </Paper>
    </FormProvider>
  );
};

export default TalentPoolAdvancesFiltersNew;
